export const calcAdd = str => {
  let tmp = str
    .split('+')
    .map(e => (isNaN(e) ? 0 : parseFloat(e)))
    .filter(e => e && !isNaN(e))
    .reduce((a, b) => a + b, 0)
  return isNaN(tmp) ? '' : tmp
}
